<template>
  <b-row>
    <div class="col-md-12">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit(1)">
          <template v-if="$route.params.id === undefined">
            <fg-input label="Supplier" v-if="$route.params.id === undefined">
              <div class="form-group input-typeahead" v-bind:class="userProfileUuidError !== null ? 'has-error':''">
                <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :labelFields="['name']" placeholder="Cari Supplier" :urlSearch="apiUrl.supplier" arr-response="data" :model="model.supplier" />
                <p v-if="userProfileUuidError !== null" class="error" v-html="userProfileUuidError"></p>
              </div>
            </fg-input>
            <fg-input label="Supplier" v-else>
              <p>{{model.supplier.name}}</p>
            </fg-input>
            <div class="form-group" v-bind:class="{ 'has-error': errors.first('poDate') }"  v-if="$route.params.id === undefined">
              <label>Tanggal PO *</label>
              <el-date-picker v-model="fakeModel.poDate" placeholder="Masukkan Tanggal Pemesanan" ></el-date-picker>
              <input v-model="model.poDate" type="hidden" v-validate="modelValidations.poDate" name="poDate" data-vv-as="tanggal order"/>
              <slot name="infoBlock"></slot>
              <slot name="helpBlock">
                <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('poDate')">
                  {{ errors.first('poDate') }}
                </div>
              </slot>
            </div>
            <fg-input label="Po Date" v-else>
              <p>{{model.poDate}}</p>
            </fg-input>
          </template>
          <!-- <fg-input label="Status">
            <p>
              <b-badge :variant="getStatusColor(model.status)">{{getStatus(model.status)}}</b-badge>
            </p>
          </fg-input> -->
          <b-row class="border ml-0 mr-0 mb-5 mt-3" v-for="(line, index) in lines" v-bind:key="index">
            <b-col md="10 p-2 mt-3">
              List Item
            </b-col>
            <b-col md="1 p-0 mt-3 text-center">
              <button type="button" @click="removeLine(index)" v-if="index >= 1" class="btn btn-danger"><i class="fa fa-times"></i></button>
            </b-col>
            <b-col md="1 p-0 mt-3 text-center">
              <b-button type="button" v-if="index + 1 === lines.length" @click="addLine" variant="primary" ><font-awesome-icon icon="plus"/></b-button>
            </b-col>
            <b-col md="12">
              <fg-input label="Product">
                <div class="form-group input-typeahead" v-bind:class="productError !== null ? 'has-error':''">
                  <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :labelFields="['product_name']" placeholder="Cari Product" :urlSearch="apiUrl.productSearch" arr-response="data" :dataLineIndex="index" :model="line.product" :formType="'productSearch'" v-on:doCreateCutomer="getSize" />
                  <p v-if="productError !== null" class="error" v-html="productError"></p>
                </div>
              </fg-input>
            </b-col>
            <b-col md="12" v-if="line.productSize.length !== 0">
              <div id="noDataLineIndexContainer" :noDataLineIndex="index" v-for="productSize in line.productSize" :key="productSize.id">
                <div class="my-4">
                    <div class="custom-control-lg custom-control custom-checkbox" style="display: inline-block; padding-right: 1rem;" v-for="color in productSize.data_color" :key="color.id">
                        <input class="custom-control-input" :id="'checkbox-warna-'+ index + '-' + color.color.id" type="checkbox" v-model="line.selectedColorId" :value="color.color.id"/>
                        <label class="custom-control-label" :for="'checkbox-warna-'+ index + '-' + color.color.id">
                            {{color.color.name }}
                        </label>
                    </div>
                </div>

                <div v-for="productSize in line.productSize" :key="productSize.id" class="table-responsive">
                  <template v-for="data_product in productSize.data_product">
                    <table class="table table-bordered table-striped mt-5" style="overflow-x: auto !important;" :key="data_product.id" v-if="line.selectedColorId.includes(data_product.color_id)">
                      <thead>
                        <tr class="text-center">
                          <th class="align-middle">Warna</th>
                          <th class="align-middle">Size</th>
                          <th class="align-middle">Stock Saat Ini</th>
                          <th class="align-middle">Stock Dipesan</th>
                          <th class="align-middle">Stock Akhir</th>
                          <th class="align-middle">Modal</th>
                          <th class="align-middle">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product_size, indx) in data_product.product_size" :key="product_size.id">
                          <template v-if="indx === 0">
                            <td width="150" class="font-weight-bold text-center align-middle" :rowspan="data_product.product_size.length">{{ data_product.color.name }}</td>
                          </template>
                          <td width="150" class="text-center">{{ product_size.size.name }}</td>
                          <td width="150" class="text-center">{{ product_size.stock }}</td>
                          <td width="150" class="text-center">
                            <b-form-input type="number" placeholder="Masukkan jumlah pesanan" v-model="product_size.ordered"></b-form-input>                            
                          </td>
                          <td width="150" class="text-center">{{ product_size.stock + parseInt(product_size.ordered) }} </td>
                          <td width="150">{{formatNumber(product_size.capital_price)}}</td>
                          <td width="150">{{ formatNumber(product_size.ordered === 0 ? product_size.capital_price * 0 : product_size.capital_price * parseInt(product_size.ordered)) }}</td>
                        </tr>
                      </tbody>
                    </table>  
                  </template>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="bubble-info" v-if="$route.params.id === undefined">   
            <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
            <b-button type="button" variant="secondary" @click="doSubmit(0)" class="mr-3">
              Simpan ke draft
            </b-button>
          </div>
          <div class="bubble-info" v-else>
            <b-button type="button" variant="secondary" @click="doSubmit(0)" class="mr-3">
              Simpan
            </b-button>
          </div>
          <cancel-button class="mr-3"/>
        </form>
      </card>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import Typeahead from '@/components/Typeahead'
  import { Radio } from '@/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch,
      Treeselect,
      Typeahead
    },
    data () {
      return {
        downPaymentDisabled: true,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          supplierPo: window.AppConfig.apiUrl + 'supplier-po',
          supplierPoProduct: window.AppConfig.apiUrl + 'supplier-po-product',
          supplier: window.AppConfig.apiUrl + 'supplier',
          productSize: window.AppConfig.apiUrl + 'product-size',
          product: window.AppConfig.apiUrl + 'product-code',
          productSearch: window.AppConfig.apiUrl + 'product-search-name'
        },
        options: [
          { text: 'Male', value: '0' },
          { text: 'Famele', value: '1' }
        ],
        userProfileUuid: {
          value: null
        },
        fakeModel: {
          poDate: ''
        },
        lines: [],
        blockRemoval: true,
        userProfileUuidError: null,
        productError: null,
        productionCost: 0,
        supplierPoList: [],
        productList: [],
        ppn: 0,
        data: null,
        model: {
          supplier: {
            value: null,
            name: null
          },
          poDate: null,
          product: {
            value: null,
            sellingPrice: null,
            capitalPrice: null
          },
          status: null
        },
        modelValidations: {
          poDate: {
            required: true
          }
        }
      }
    },
    computed: {
    },
    mounted () {
      this.initData()
      this.addLine()
    },
    watch: {
      lines () {
        this.blockRemoval = this.lines.length <= 1
      },
      'fakeModel.poDate' (value) {
        this.model.poDate = value !== null ? this.$moment(value).format('YYYY-MM-DD') : null
      }
    },
    methods: {
      getSize (value) {
        if (value.isRemove) {
          this.lines[value.dataLineIndex].productSize = []
        } else {
          this.$http.get(this.apiUrl.product + '/' + value.id).then(resp => {
            resp.data.forEach(data => {
              this.lines[value.dataLineIndex].productSize.push({
                data_product: data.product_category.product_color,
                data_color: data.colors.product_category.product_color
              })
              this.lines[value.dataLineIndex].productSize.forEach(data => {
                data.data_product.forEach(data2 => {
                  data2.product_size.forEach(data3 => {
                    this.$set(data3, 'ordered', 0)
                  })
                })
              })
            })
          })
        }
      },
      initData () {
        if (this.$route.params.id !== undefined) {
          // this.getDetail()
        }
      },
      addLine () {
        // let checkEmptyLines = this.lines.filter(line => line.color === null)
        // if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        this.lines.push({
          product: {
            value: null,
            sellingPrice: 0,
            capitalPrice: 0
          },
          productSize: [],
          ordered: 0,
          accepted: 0,
          selectedColorId: []
        })
      },
      removeLine (lineId) {
        if (!this.blockRemoval) this.lines.splice(lineId, 1)
      },
      getProduct (val) {
        this.$http.get(this.apiUrl.productSearch + '?name=' + val).then(resp => {
          this.productList = []
          // console.log(resp.data.data)
          resp.data.data.forEach(data => {
            this.productList.push({
              id: data.id,
              label: data.product_name
            })
          })
        })
      },
      // getDetail () {
      //   this.isLoading = true
      //   this.$http.get(this.apiUrl.supplierPo + '/' + this.$route.params.id)
      //   .then(response => {
      //     this.model.supplier.value = response.data.supplier.id
      //     this.model.supplier.name = response.data.supplier.name
      //     this.model.poDate = this.$moment(response.data.po_date).format('DD-MM-YYYY')
      //     this.model.status = response.data.status
      //     response.data.supplier_po_product.forEach(data => {
      //       this.lines.push({
      //         product: {
      //           id: data.id,
      //           value: data.product_size.id,
      //           name: data.product_size.product_color.product_categories.product.name,
      //           category: data.product_size.product_color.product_categories.category.name,
      //           color: data.product_size.product_color.color.name,
      //           size: data.product_size.size.name,
      //           capitalPrice: data.product_size.capital_price,
      //           sellingPrice: data.product_size.selling_price
      //         },
      //         ordered: data.ordered,
      //         accepted: data.accepted
      //       })
      //     })
      //     this.isLoading = false
      //   })
      //   .catch(error => {
      //     this.isLoading = false
      //     this.$store.dispatch('notification/error', error)
      //     // this.$router.push('/notfound')
      //   })
      // },
      doSubmit (typeStatus = null) {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Sudah',
          cancelButtonText: 'Tidak, belum',
          confirmButtonClass: 'btn btn-danger mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$validator.validateAll().then(res => {
              if (res) {
                if (this.$route.params.id === undefined && (this.model.supplier.value === null || this.model.supplier.value === '')) {
                  this.userProfileUuidError = 'This field is required'
                  this.$store.dispatch('notification/error', 'Mohon periksa kembali inputan anda')
                } else {
                  let model = {
                    poDate: this.model.poDate,
                    supplier: this.model.supplier.value,
                    status: typeStatus,
                    products: []
                  }
                  this.lines.forEach(data => {
                    data.productSize.forEach(data2 => {
                      data2.data_product.forEach(data3 => {
                        data3.product_size.forEach(data4 => {
                          if (data4.ordered !== 0) {
                            model.products.push({
                              productSize: data4.id,
                              product_color_id: data4.product_color_id,
                              ordered: parseInt(data4.ordered),
                              last_stock: parseInt(data4.stock) + parseInt(data4.ordered)
                            })
                          }
                        })
                      })
                    })
                  })
                  if (this.$route.params.id === undefined) {
                    this.$http.post(this.apiUrl.supplierPo, model).then(response => {
                      this.saveButtonData.isLoading = false
                      this.$store.dispatch('notification/success', 'Item berhasil ditambahkan.')
                      window.location.href = document.URL.replace('/create', '/' + response.data.id)
                    }).catch(error => {
                      this.saveButtonData.isLoading = false
                      this.$store.dispatch('notification/error', error)
                    })
                  } else {
                    this.$http.patch(this.apiUrl.supplierPoProduct + '/' + this.$route.params.id, {
                      products: model.products
                    }).then(response => {
                      this.saveButtonData.isLoading = false
                      this.$store.dispatch('notification/success', 'Item berhasil ditambahkan.')
                      window.location.href = document.URL.replace('/edit', '/')
                    }).catch(error => {
                      this.saveButtonData.isLoading = false
                      this.$store.dispatch('notification/error', error)
                    })
                  }
                }
              } else {
                this.$store.dispatch('notification/error', 'Mohon periksa kembali inputan anda')
              }
            })
          }
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Dipesan'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Diterima'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Dibatalkan'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
        }
      }
    }
  }
</script>
<style scooped>
.custom-control-lg .custom-control-label::before,
.custom-control-lg .custom-control-label::after {
    top: 0.1rem !important;
    left: -2rem !important;
    width: 1.25rem !important;
    height: 1.25rem !important;
}

.custom-control-lg .custom-control-label {
    margin-left: 0.5rem !important;
    font-size: 15px !important;
}
  .fixed-top-selling {
    position: fixed;
    float: right !important;
    /* top: 0; */
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .mt-4-5 {
    margin-top: 2rem !important;
  }
  .bubble-info {
    position: fixed;
    right: 25px;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Pos/Form.vue